import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState, useCallback, } from "react";
import Swal from "sweetalert2";
import api from "../../services/api";
import "./GlobalAlertas.scss";
import som_notificacao from "./notificacao.mp3";
import { formatarMensagem, formatarTipo } from "../Notificacao/Formatacao_alerta";
import logo from "../../assets/logo.png";

function GlobalAlertas() {
  const [filaAlertas, setFilaAlertas] = useState([]);

  const cooldownAlertas = useRef({});
  const filaRef = useRef([]);
  const navigate = useNavigate();
  const desabilitarProximo = filaAlertas.length <= 1;
  const [tempoRestante, setTempoRestante] = useState(15);
  const tempoRef = useRef(15);
  const inicioRef = useRef(Date.now());
  const [observacao, setObservacao] = useState("");

  const [mostrarObs, setMostrarObs] = useState(false);
  const [obs, setObs] = useState("");
  const [alertaAtual, setAlertaAtual] = useState(null);
  const [pausado, setPausado] = useState(false);
  const intervaloRef = useRef(null);
  const timeoutRef = useRef(null);



  //CHAMA O ALERTA DE OBSERVAÇÃO PARA O USUÁRIO DIGITAR O MOTIVO PELO QUAL NÃO QUER MAIS VER O ALERTA
  const naoAvisarMais = async () => {
    const alerta = filaAlertas[0];
    if (!alerta) return;

    // 1. PAUSA TUDO
    setPausado(true);

    //  2. LIMPA TIMEOUT ATUAL (evita troca durante modal)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    //  3. ABRE MODAL PARA DIGITAR OBSERVAÇÃO
    const { value: obs } = await Swal.fire({
      title: `
    <div style="
      font-size:16px;
      font-weight:600;
      letter-spacing:1.2px;
      color:#cbd5f5;
      text-align:center;
    ">
      FINALIZAR ALERTA
    </div>
    `,

      html: `
      <div style="position:relative;">

      <!--  LOGO IGUAL AO ::before -->
      <div style="
      position:absolute;
      inset:0;
      background:url(${logo}) no-repeat center;
      background-size:140px;
      opacity:0.06;
      pointer-events:none;
       "></div>

    <!-- CONTEÚDO -->
    <div style="position:relative; z-index:2; text-align:left; margin-top:12px;">

      <div style="
        background: rgba(0,0,0,0.15);
        border: 1px solid rgba(255,255,255,0.08);
        padding:16px;
        border-radius:10px;
        margin-bottom:14px;
      ">

        <div style="
          font-size:16px;
          font-weight:700;
          color:#60a5fa;
          margin-bottom:8px;
        ">
          ${alerta.placa}
        </div>

        <div style="margin-bottom:8px;">
          <span style="color:#8aa4c8; font-size:12px;">Tipo</span><br/>
          <span style="color:#f59e0b; font-weight:600;">
            ${formatarTipo(alerta.tipo)}
          </span>
        </div>

        <div>
          <span style="color:#8aa4c8; font-size:12px;">Mensagem</span><br/>
          <span style="color:#e2e8f0; font-size:13px;">
            ${formatarMensagem(alerta.mensagem, alerta.tipo)}
          </span>
        </div>

        <div>
          <span style="color:#8aa4c8; font-size:12px;">Localização</span><br/>
          <span style="color:#e2e8f0; font-size:13px;">
            ${alerta.endereco || "Endereço não disponível"}
          </span>
        </div>

      </div>

      <div style="font-size:12px; color:#8aa4c8;">
        Observação obrigatória
      </div>

    </div>
  </div>
`,

      input: "textarea",
      inputPlaceholder: "Digite o motivo da finalização...",

      showCancelButton: true,
      confirmButtonText: "Finalizar",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "#2563eb",
      cancelButtonColor: "#1e293b",

      //  AQUI É O SEGREDO (gradiente + logo)
      background: `
  linear-gradient(
    135deg,
    #061b31f2 0%,
    #082846fe 55%,
    #061b31 100%
  )
`,

      color: "#fff",

      inputAttributes: {
        style: `
      background:#061b31;
      color:#fff;
      border:1px solid rgba(255,255,255,0.12);
      border-radius:8px;
      padding:12px;
      font-size:14px;
      outline:none;
    `
      },

      customClass: {
        popup: "swal-alerta-central"
      },

      inputValidator: (value) => {
        if (!value || value.trim() === "") {
          return "Digite uma observação obrigatória!";
        }
      },

      allowOutsideClick: false,
      allowEscapeKey: false
    });
    // 4. SE CANCELAR → VOLTA NORMAL
    if (!obs) {
      setPausado(false);
      return;
    }

    try {
      Swal.fire({
        title: "Finalizando notificação...",

        html: `
    <div style="margin-top:10px">

      <div style="
        color:#cbd5e1;
        font-size:15px;
        margin-bottom:20px;
      ">
        Aguarde enquanto processamos a solicitação.
      </div>

      <div style="
        display:flex;
        justify-content:center;
        align-items:center;
      ">
        <div style="
          width:58px;
          height:58px;
          border:4px solid rgba(255,255,255,0.08);
          border-top:4px solid #38bdf8;
          border-right:4px solid #0ea5e9;
          border-radius:50%;
          animation: spinSwal 0.8s linear infinite;
        "></div>
      </div>

      <div style="
        margin-top:18px;
        color:#64748b;
        font-size:13px;
      ">
        Isso pode levar alguns segundos...
      </div>

    </div>

    <style>
      @keyframes spinSwal {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    </style>
  `,

        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,

        background: `
    linear-gradient(
      135deg,
      #061b31f2 0%,
      #082846fe 55%,
      #061b31 100%
    )
  `,

        color: "#ffffff"
      });
      // ENVIA PRO BACKEND
      await api.put(
        `/alertas/finalizar/card/${alerta.id_ocorrencia}`,
        {
          finalizado_por: localStorage.getItem("clientID"),
          obs
        }
      );
      // //  6. SALVA LOCALMENTE (IGNORADOS)
      // const chave = String(alerta.id_ocorrencia);
      // const ignorados = JSON.parse(
      //   localStorage.getItem("alertasIgnorados") || "[]"
      // );

      // ignorados.push(chave);

      // localStorage.setItem(
      //   "alertasIgnorados",
      //   JSON.stringify([...new Set(ignorados)])
      // );

      //  7. FLUXO DE ALERTAS
      if (filaAlertas.length > 1) {
        tempoRef.current = 15;
        setTempoRestante(15);
        proximoAlerta();
      } else {
        setFechando(true);

        setTimeout(() => {
          setFilaAlertas([]);
          setFechando(false);
        }, 260);
      }

      // 8. FEEDBACK
      Swal.fire({
        icon: "success",

        title: `
    <div style="
      font-size:18px;
      font-weight:700;
      color:#e2e8f0;
      letter-spacing:0.5px;
    ">
      Notificação finalizada!
    </div>
  `,

        html: `
    <div style="
      margin-top:10px;
      color:#94a3b8;
      font-size:14px;
      line-height:1.5;
    ">
      A ocorrência foi finalizada com sucesso.
    </div>
  `,

        timer: 1600,
        showConfirmButton: false,

        background: `
    linear-gradient(
      135deg,
      #061b31f2 0%,
      #082846fe 55%,
      #061b31 100%
    )
  `,

        color: "#ffffff",

        customClass: {
          popup: "swal-alerta-central"
        }
      });

    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        title: "Erro ao finalizar"
      });
    }

    // 9. LIBERA O TIMER (UMA VEZ SÓ)
    setPausado(false);
  };


  //CONTROLE DO TEMPO DE EXIBIÇÃO DO ALERTA E PAUSA QUANDO O USUÁRIO FOR DIGITAR A OBSERVAÇÃO
  useEffect(() => {
    //  se pausado → não roda nada
    if (pausado) return;

    const intervalo = setInterval(() => {
      setTempoRestante((prev) => {
        const novoTempo = Math.max(prev - 1, 0);

        //  mantém o ref sincronizado
        tempoRef.current = novoTempo;

        //  quando chega no fim
        if (prev <= 1) {
          tempoRef.current = 15; // RESET CORRETO

          proximoAlerta(); //  troca alerta

          return 15;
        }

        return novoTempo;
      });
    }, 1000);

    //  limpa sempre (evita múltiplos intervalos)
    return () => clearInterval(intervalo);
  }, [pausado]);



  useEffect(() => {
    filaRef.current = filaAlertas;
  }, [filaAlertas]);





  // BUSCA ALERTAS NOVOS A CADA 60 SEGUNDOS
  const buscarAlertas = useCallback(async () => {
    try {
      const { data } = await api.get("/alertas", {
        params: {
          page: 1,
          limit: 20
        },
        headers: {
          typo: localStorage.getItem("id")
        }
      });

      const lista = data?.notificacoes_alertas || [];


      if (!lista.length) return;

      const agora = Date.now();

      const ignorados = JSON.parse(
        localStorage.getItem("alertasIgnorados") || "[]"
      );

      const novos = lista.filter((item) => {
        //  chave única e confiável
        const chave = String(item.id_ocorrencia);

        // ignora se usuário marcou
        if (ignorados.includes(chave)) {
          return false;
        }

        // cooldown por alerta
        const ultimaExibicao =
          cooldownAlertas.current[item.id_ocorrencia] || 0;

        const passouCooldown =
          agora - ultimaExibicao > 1500; // 1.5s (ajustável)

        // evita duplicar na fila
        const jaNaFila =
          filaRef.current.some(
            (x) =>
              x.id_ocorrencia === item.id_ocorrencia
          );

        return passouCooldown && !jaNaFila;
      });

      if (!novos.length) return;

      // marca cooldown
      novos.forEach((item) => {
        cooldownAlertas.current[item.id_ocorrencia] = agora;
      });

      // adiciona na fila
      setFilaAlertas((prev) => [
        ...prev,
        ...novos.reverse()
      ]);

      //  som
      const audio = new Audio(som_notificacao);
      audio.volume = 1;
      audio.play().catch(() => { });


      if (filaRef.current.length === 0 && novos.length > 0) {
        //  reinicia timer quando chega alerta novo
        inicioRef.current = Date.now();
      }

    } catch (error) {
      console.log("Erro ao buscar alertas:", error);
    }
  }, []);

  //BUSCA ALERTA A CADA 20 SEGUNDOS E FILTRA OS QUE O USUÁRIO OPTOU POR NÃO VER
  useEffect(() => {

    // executa ao abrir
    buscarAlertas();

    const interval = setInterval(() => {

      // busca alertas
      buscarAlertas();

      // atualiza outros componentes
      window.dispatchEvent(
        new Event("atualizar_alertas")
      );

    }, 60000); // a cada 60 segundos

    return () => clearInterval(interval);

  }, [buscarAlertas]);

  //RESPOSÁVEL POR CONTROLAR O TEMPO DE EXIBIÇÃO DE CADA ALERTA E A TRANSIÇÃO ENTRE ELES
  useEffect(() => {
    if (!filaAlertas.length || pausado) return;

    //  REMOVER ISSO:
    // setTempoRestante(15);

    // limpa anterior
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    //  usa tempo restante real
    const tempoMs = Math.max(tempoRef.current, 1) * 1000;
    timeoutRef.current = setTimeout(() => {
      if (pausado) return;

      if (filaRef.current.length > 1) {
        setTrocando(true);

        setTimeout(() => {
          setFilaAlertas((prev) => prev.slice(1));
          setTrocando(false);
        }, 180);
      } else {
        setFechando(true);

        setTimeout(() => {
          setFilaAlertas([]);
          setFechando(false);
        }, 260);
      }
    }, tempoMs);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [filaAlertas, pausado]);









  const [trocando, setTrocando] = useState(false);


  //PROXIMO ALERTA MANUAL, QUANDO O USUÁRIO CLICA NO BOTÃO "PRÓXIMO" PARA VER O PRÓXIMO ALERTA SEM PRECISAR ESPERAR O TEMPO ACABAR
  const proximoAlerta = () => {
    if (filaAlertas.length <= 1) return; // trava aqui

    setTrocando(true);
    tempoRef.current = 15;
    setTempoRestante(15);

    setTimeout(() => {
      setFilaAlertas((prev) => prev.slice(1));
      setTrocando(false);
    }, 180);
  };




  const [fechando, setFechando] = useState(false);
  const fecharTudo = () => {
    setFechando(true);

    setTimeout(() => {
      setFilaAlertas([]);
      setFechando(false);
    }, 260);
  };

  const verMais = () => {
    navigate("/maps/alertas");
  };

  if (!filaAlertas.length) return null;

  const alerta = filaAlertas[0];
  console.log(alerta)

  const qtdPlaca = filaAlertas.filter(
    (item) =>
      item.placa === alerta.placa
  ).length;

  const corTipo = () => {
    const tipo =
      alerta.tipo?.toLowerCase() || "";

    if (tipo.includes("bateria"))
      return "#facc15";

    if (
      tipo.includes("velocidade")
    )
      return "#fb923c";

    if (tipo.includes("ignição"))
      return "#22c55e";

    return "#38bdf8";
  };

  return (
    
    <div
      className={`div-alerta ${fechando ? "div-alerta-fechando" : ""
        }`}
    >
      <div className="div-headerAlerta">
        <div className="div-card">
          <div className="titulo-alerta">
            CENTRAL DE ALERTAS
          </div>

          <div className="subtitulo-alerta" style={{ paddingTop: "4px" }}>
            {filaAlertas.length} pendente(s)
          </div>
          <div className="data-alerta">
            {new Date(
            ).toLocaleString("pt-BR")}
          </div>
        </div>

        <button
          onClick={fecharTudo}
          disabled={pausado}
          className={`
    btn-fechar 
    ${fechando ? "btn-fechar-animando" : ""}
    ${pausado ? "btn-desabilitado" : ""}
  `}
        >
          ✕
        </button>
      </div>
      <div
        className={`alerta-body ${trocando ? "troca-alerta" : ""
          }`}
      >
        <div className="alerta-topo">
          <div className="placa-alerta">
            {alerta.placa}
            <p style={{
              fontSize:"9pt"
            }}>{alerta.nome}</p>
          </div>

          {qtdPlaca > 1 && (
            <span className="badge-alerta">
              +{qtdPlaca - 1}
            </span>
          )}

        </div>



        <div
          style={{
            background: "rgba(15, 23, 42, 0)",
            border: "none",
            borderRadius: "12px",
            padding: "14px",
            marginTop: "-16px"
          }}
        >
          {/* TIPO */}
          <div style={{ marginBottom: "0px" }}>
            <span style={{ color: "#64748b", fontSize: "13px" }}>
              Tipo
            </span>
            <div
              style={{
                color: corTipo(),
                fontWeight: "700",
                fontSize: "15px"
              }}
            >
              {formatarTipo(alerta.tipo)}
            </div>
          </div>

          {/* MENSAGEM */}
          <div style={{ marginBottom: "10px" }}>
            <span style={{ color: "#64748b", fontSize: "13px" }}>
              Mensagem
            </span>
            <div
              style={{
                color: "#e2e8f0",
                fontSize: "14px",
                fontWeight: "500"
              }}
            >
              {formatarMensagem(alerta.mensagem, alerta.tipo)}
            </div>
          </div>

          {/* LOCALIZAÇÃO */}
          <div>
            <span style={{ color: "#64748b", fontSize: "13px" }}>
              Localização
            </span>
            <div
              style={{
                color: "#cbd5e1",
                fontSize: "14px"
              }}
            >
              {alerta.endereco || "Endereço não disponível"}
            </div>
          </div>
        </div>

        <div className="data-alerta">
          {alerta.data_posicao
            ? new Date(
              alerta.data_posicao
            ).toLocaleString("pt-BR")
            : "Data/hora Indisponível"}
        </div>



        <div className="barra-tempo">
          <div
            key={`${alerta.id_ocorrencia}-${pausado}`} //  ESSA LINHA É O SEGREDO
            className="barra-progresso"
            style={{
              width: `${(tempoRestante / 15) * 100}%`,
              transition: pausado ? "none" : "width 1s linear"
            }}
          />
        </div>

        <div className="botoes-alerta">
          <button
            onClick={verMais}
            className="btn-principal"
          >
            Ver Mais
          </button>

          <button
            onClick={proximoAlerta}
            className="btn-secundario"
            disabled={filaAlertas.length <= 1 || pausado}
          >
            Próximo
          </button>


          <button
            onClick={naoAvisarMais}
            className="btn-nao-mostrar"
          >
            Finalizar Alerta
          </button>
        </div>
      </div>
    </div>
  );
}

export default GlobalAlertas;